var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5px",
    height: "21px",
    viewBox: "0 0 5 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "032B129F-4AA8-46E3-BE02-23135BEF2D2F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-957.000000, -771.000000)",
    fill: "#6D747E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(957.000000, 771.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 2.5,
    cy: 10.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 2.5,
    cy: 18.5,
    r: 2.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotMenuIcon);
export default __webpack_public_path__ + "static/media/dot-menu-icon.697d3348850ae4ee7a3c856db22c7ed4.svg";
export { ForwardRef as ReactComponent };